import React, { useEffect, useState } from "react";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  UploadAdapter,
  FileLoader,
} from "@ckeditor/ckeditor5-upload/src/filerepository";
import { useSession } from "next-auth/react";

// Static imports
import Editor from "../../ckeditor/build/ckeditor";
import { VeTypography } from "@packages/ui/mui";

const UPLOAD_CKEDITOR_URL = `${process.env.NEXT_PUBLIC_VERICAP_BACKEND}/files/upload`;

// Upload images functionality
function uploadAdapter(loader: FileLoader, session: any): UploadAdapter {
  return {
    upload: () => {
      return new Promise(async (resolve, reject) => {
        try {
          const file: any = await loader.file;
          const formData = new FormData();
          formData.append("files", file);
          formData.append("bucket", process.env.NEXT_PUBLIC_BUCKET_NAME || "");
          const response = await axios.request({
            method: "POST",
            url: `${UPLOAD_CKEDITOR_URL}`,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${session?.user.token}`,
              deviceId: session?.user.deviceId,
            },
          });
          resolve({
            default: `${process.env.NEXT_PUBLIC_BUCKET}/${response.data.data.fileNames[0]?.objectKey}`,
          });
        } catch (error) {
          console.log("error", error);
          reject("Unable to upload media file. Please try again.");
        }
      });
    },
    abort: () => {},
  };
}

function TextEditor({
  value,
  handleOnBlur,
  placeholder,
  disabled = false,
  required = false,
  error = false,
  errorText = "",
}: any) {
  const [editorText, setEditorText] = useState("");

  useEffect(() => {
    setEditorText(value);
  }, [value]);

  const { data: session } = useSession();
  return (
    <div className="App">
      <div>
        <CKEditor
          disabled={disabled}
          editor={Editor as any}
          config={{
            placeholder,
            extraPlugins: [
              function uploadPlugin(editor: any) {
                editor.plugins.get("FileRepository").createUploadAdapter = (
                  loader: any,
                ) => {
                  return uploadAdapter(loader, session);
                };
              },
            ],
          }}
          // onReady={(editor) => {
          // }}
          onBlur={() => {
            if (!disabled) {
              handleOnBlur(editorText);
            }
          }}
          onChange={(event: any, editor: any) => {
            setEditorText(editor.getData());
          }}
          data={value}
        />
      </div>
      {error && (
        <VeTypography
          style={{ marginLeft: "10px" }}
          variant="label4ErrorPrimary"
        >
          {errorText}
        </VeTypography>
      )}
    </div>
  );
}

export default TextEditor;
